export const colorArray = [
  "#43ACFF",
  "#EF5261",
  "#FAC300",
  "#9AD888",
  "#18B0A7",
  "#3C78D8",
  "#43ACFF",
  "#EF5261",
  "#FAC300",
  "#9AD888",
];
